import styled from "styled-components"
import { silver } from "css/variables/_colors.scss"

const StyledBaseBubble = styled.div`
  padding: 22px;
  border: 2px solid ${silver};
  border-radius: 8px;
`

const StyledChatBubble = styled(StyledBaseBubble)`
  position: relative;
  margin-bottom: 20px;
  &::before {
    content: "";
    width: 0;
    height: 0;
    position: absolute;
    border-left: 15px solid ${silver};
    border-right: 15px solid transparent;
    border-top: 11px solid ${silver};
    border-bottom: 11px solid transparent;
    left: 20px;
    bottom: -22px;
  }
  &::after {
    content: "";
    width: 0;
    height: 0;
    position: absolute;
    border-left: 15px solid white;
    border-right: 15px solid transparent;
    border-top: 11px solid white;
    border-bottom: 11px solid transparent;
    left: 22px;
    bottom: -18px;
  }
`

export { StyledBaseBubble, StyledChatBubble }
